import service from '@/api/patientCatalog';
import {loading, handleError} from '@/state/generators/helpers';

export const state = {
    loading: false,
    service: service('patient'),
    components: [],
    medicines: [],
    errors: {}
};

export const getters = {
    loading: function (state) {
        return !!state.loading;
    },
    components: function (state) {
        return state.components;
    },
    medicines: function (state) {
        return state.medicines;
    },

    componentByVersionId: (state) => (versionId) => {
        return state.components.find(component => component.current_version?.id === versionId) || null;
    },

    groupedComponents: function (state) {
        const groups = [];

        state.components.forEach(component => {
            const name = component.group?.name || '';
            let group = groups.find(candidate => candidate.name === name);

            if (!group) {
                group = {name: name, position: component.group?.position ?? 999, components: []};
                groups.push(group);
            }

            group.components.push(component);
        });

        return groups.sort((a, b) => a.position - b.position);
    }
};

export const mutations = {
    'SET_LOADING': function (state, boolean = true) {
        state.loading = boolean;
    },
    'SET_COMPONENTS': function (state, components = []) {
        state.components = components;
    },
    'SET_MEDICINES': function (state, medicines = []) {
        state.medicines = medicines;
    },
    'SET_ERRORS': function (state, errors = {}) {
        state.errors = errors;
    }
};

export const actions = {
    components: function ({commit, state}, force) {
        if (state.components.length && !force) {
            return Promise.resolve(state.components);
        }

        loading(commit);

        return state.service.fetchComponents().then(response => {
            commit('SET_COMPONENTS', response.data);
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    medicines: function ({commit, state}, force) {
        if (state.medicines.length && !force) {
            return Promise.resolve(state.medicines);
        }

        loading(commit);

        return state.service.fetchMedicines().then(response => {
            commit('SET_MEDICINES', response.data);
            loading(commit, false);
            return response.data;
        }).catch((e) => {
            return handleError(e, commit);
        });
    },

    clearModule: function ({commit}) {
        commit('SET_COMPONENTS', []);
        commit('SET_MEDICINES', []);
        commit('SET_ERRORS', {});
    }
};
